import { render, staticRenderFns } from "./AdministratorView.vue?vue&type=template&id=75341f16&scoped=true&"
import script from "./AdministratorView.vue?vue&type=script&lang=js&"
export * from "./AdministratorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75341f16",
  null
  
)

export default component.exports